module.exports = __webpack_public_path__ + "static/media/4.9226ea70.jpg";